"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.series = void 0;
/**
 * Creates a series object around a list of values
 * that should be treated with order.
 */
var series = function () {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    var _a = items.reduce(function (acc, item, idx) {
        var _a, _b;
        return ({
            itemsByValue: __assign(__assign({}, acc.itemsByValue), (_a = {}, _a[item] = idx, _a)),
            itemsByIndex: __assign(__assign({}, acc.itemsByIndex), (_b = {}, _b[idx] = item, _b))
        });
    }, {
        itemsByValue: {},
        itemsByIndex: {}
    }), itemsByValue = _a.itemsByValue, itemsByIndex = _a.itemsByIndex;
    return {
        /**
         * Given two values in the series, returns the
         * value that occurs later in the series
         */
        min: function (a, b) {
            return itemsByValue[a] < itemsByValue[b] ? a : b;
        },
        /**
         * Given two values in the series, returns the
         * value that occurs earlier in the series
         */
        max: function (a, b) {
            return itemsByValue[a] > itemsByValue[b] ? a : b;
        },
        /**
         * Returns the first item from the series
         */
        first: function () {
            return itemsByIndex[0];
        },
        /**
         * Returns the last item in the series
         */
        last: function () {
            return itemsByIndex[items.length - 1];
        },
        /**
         * Given an item in the series returns the next item
         * in the series or default if the given value is
         * the last item in the series
         */
        next: function (current, defaultValue) {
            var _a;
            return (_a = itemsByIndex[itemsByValue[current] + 1]) !== null && _a !== void 0 ? _a : defaultValue;
        },
        /**
         * Given an item in the series returns the previous item
         * in the series or default if the given value is
         * the first item in the series
         */
        previous: function (current, defaultValue) {
            var _a;
            return (_a = itemsByIndex[itemsByValue[current] - 1]) !== null && _a !== void 0 ? _a : defaultValue;
        }
    };
};
exports.series = series;
//# sourceMappingURL=series.js.map